var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    {
      staticClass: "sidebar-shell",
      class: { "sidebar-shell--mobile": _vm.mobile },
      style: _vm.asideStyle
    },
    [
      _vm.accentTop
        ? _c("div", {
            staticClass: "sidebar-shell__accent",
            style: { background: _vm.accentColor }
          })
        : _vm._e(),
      !_vm.mobile
        ? _c(
            "button",
            {
              staticClass: "sidebar-shell__toggle",
              attrs: { type: "button", title: _vm.toggleTitle },
              on: {
                click: function($event) {
                  return _vm.$emit("toggle")
                }
              }
            },
            [
              _c("icon-svg", {
                attrs: {
                  name: _vm.toggleIcon,
                  size: _vm.TOGGLE_ICON_SIZE,
                  color: "#030309"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "sidebar-shell__brand" }, [_vm._t("brand")], 2),
      _c("div", { staticClass: "sidebar-shell__body" }, [_vm._t("default")], 2),
      !_vm.collapsed && _vm.$slots.footer
        ? _c(
            "div",
            { staticClass: "sidebar-shell__footer" },
            [_vm._t("footer")],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }